import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/besondere-bedingungen/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="SpecialCondition"
      returnRoute="/auswahlfelder/specialCondition"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const SpecialConditionRoute = Route;
